import { Button, List, message, Tag, Tooltip } from 'antd';
import React, {useEffect, useState, useContext} from 'react'
import { useFetch, sortByDate } from '@utils';
import getCharacterStatus from '../components/character/GetCharacterStatusTag'

import {getEventDate, getMyRegistration} from '../components/Registration/functions';
import { appContext } from '../AppContext';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom/cjs/react-router-dom';

export default function RegistrationsPage() {

    const [dataSource, setDataSource] = useState([]);
    const [doFetch] = useFetch();
    // const [currentEvent, setCurrentEvent] = useState(undefined);
    const [appState] = useContext(appContext);
    const history = useHistory();

    useEffect(() => {
        doFetch("/api/event")
        .then((response) => dataLoaded(response.isSuccess, response.result))

        function dataLoaded(isSuccess, result) {
            if(isSuccess) {
                const tempArray = result.sort((a, b) => sortByDate(a.startDate, b.startDate))
                let temp = getListItems(tempArray);
                setDataSource(temp);
                return;
            }

            message.error('Events failed to load')
        }
    }, //eslint-disable-next-line
    [] )

        function onClickShow(record) {

            history.push(`/${appState.appName}/registration/event?id=${record.id}`)
        }

        function getListItems(list) {
            return list.map(_ => {
                return (
                    <List.Item
                        onClick={() => onClickShow(_) }
                        key={_.id}
                          extra={[
                            // getTag(_),
                            <Button onClick={() => onClickShow(_) }>View</Button>
                          ]}
                        //   onClick={() => onRowClick(_)}
                        >
            
                          <List.Item.Meta
                            style={{width:"100%"}}
                            title={`${_.story} ${_.sequenceNumber}`}
                            description={getEventDate(_)}
                          />
                          {getTag(_)}
                          {/* {getPrice(_)} */}
                        </List.Item>
                )

                function getTag(record) {
                    const myRegistration = getMyRegistration(record.registrations, appState.user.id)

                    if(myRegistration === null || myRegistration === undefined) {
                        return null;
                    }

                    function addCharacterTag() {
                        if(!myRegistration.character) {
                            if(myRegistration.registrationTypeDisplayName === 'Player'
                            && record.story !== "Zomerlarp") {
                                return <Tag color="warning">No character selected</Tag>
                            }  
                            return null;
                        }


                        const character = myRegistration.character;
                        

                        return (
                            <>
                                <br />
                                <br />
                                <h4>Character</h4>
                                <Link to={`character?id=${character.id}`}>{character.name}</Link>
                                <br />
                                {getCharacterStatus(character)}
                            </>
                        )
                    }

                    if(myRegistration.paidConfirmation) {
                        return <>
                            <Tag color="success">Registered</Tag>
                            <Tag color="success">Paid</Tag>
                            <Tag>{myRegistration.registrationTypeDisplayName}</Tag>
                            {addCharacterTag()}
                        </>
                    }

                    return (
                        <>
                            <Tag color="success">Registered</Tag>
                            <Tooltip title="An admin need to set this to paid. Check the registration itself to see the full details of payment"><Tag color="warning">Not Paid</Tag></Tooltip>
                            <Tag>{myRegistration.registrationTypeDisplayName}</Tag>
                            {addCharacterTag()}
                    </>)
                }
              })
        }


    return (
        <>
            <List
                itemLayout="vertical"
                dataSource={dataSource}
                pagination={{
                    pageSize: 10,
                }}
                renderItem={item =>
                    item
                }
            /> 
        </>
    )
}